import $ from 'jquery';
import sessionTimeout from './sessionTimeout';

function onInputChange() {
    const $inputs = $('.js-cvr input');
    if ($inputs.length < 1) return;

    $inputs.on('input', function () {
        const $this = $(this);
        const $ancestor = $this.closest('.js-company');
        $this.rules('remove', 'cvrSuccess');

        if ($this.val().length === 0) {
            enableComplainant($ancestor);
            return;
        }

        $this.val($this.val().replace(' ', ''));
        if ($this.val().length !== 8) {
            enableComplainant($ancestor);
            return;
        }

        $.get($ancestor.find('.js-cvr').data('api') + '?id=' + $this.val(), function (data) {
            sessionTimeout.resetTimers();

            let responseSuccess = (data !== undefined && data !== null);

            $this.rules('add', {
                cvrSuccess: {
                    isSuccess: responseSuccess 
                }
            });

            if (responseSuccess) {
                setAndDisable($ancestor.find('input[name*=".Name"]'), data.Name);
                setAndDisable($ancestor.find('input[name*=".Address"]'), data.Address);
                setAndDisable($ancestor.find('input[name*=".ZipCode"]'), data.ZipCode);
                setAndDisable($ancestor.find('input[name*=".City"]'), data.City);
                setAndDisable($ancestor.find('input[name*=".Email"]'), data.Email);
                setAndDisable($ancestor.find('input[name*=".Phone"]'), data.Phone);
                // Handle input for country select
                let countryOptionValue = $ancestor.find('option[data-modal-body*="modal-CountryOption.' + data.Country + '"]').val();
                if (countryOptionValue != null && countryOptionValue != undefined) {
                    $ancestor.find('select[name*=".Country"]').val(countryOptionValue).prop('readonly', true).valid();
                }
            } else {
                $ancestor.find('input[name*=".Name"]').prop('readonly', false);
                $ancestor.find('input[name*=".Address"]').prop('readonly', false);
                $ancestor.find('input[name*=".ZipCode"]').prop('readonly', false);
                $ancestor.find('input[name*=".City"]').prop('readonly', false);
                $ancestor.find('input[name*=".Email"]').prop('readonly', false);
                $ancestor.find('input[name*=".Phone"]').prop('readonly', false);
                $ancestor.find('select[name*=".Country"]').prop('readonly', false);
            }
        });
    });
}

function setAndDisable(jQuery, val) {
    if (val == null || val == undefined) {
        return jQuery.prop('readonly', false).valid();
    } else if ((typeof val == "number" && val >= 0)
                || (typeof val == "string" && val.length > 0)) {
        return jQuery.val(val).prop('readonly', true).valid();
    }
    return false;
}

function enableComplainant(company) {
    company.find('input[name*=".Name"]').prop('readonly', false);
    company.find('input[name*=".Address"]').prop('readonly', false);
    company.find('input[name*=".ZipCode"]').prop('readonly', false);
    company.find('input[name*=".City"]').prop('readonly', false);
    company.find('input[name*=".Email"]').prop('readonly', false);
    company.find('input[name*=".Phone"]').prop('readonly', false);
    company.find('select[name*=".Country"]').prop('readonly', false);
}

export function initEvents() {
    onInputChange();
}

export function initValidation($form) {
    /// <summary>WARNING: requires the ancestor form to have initialized validation with the .validate() function</summary>
    const $inputs = $form.find('.js-cvr input');
    if ($inputs.length < 1) return;

    $inputs.each(function () {
        $(this).rules('add',
            {
                digits: true,
                minlength: 8,
                maxlength: 8
            });
    });
}

export default {
    initEvents,
    initValidation
};
